<template>
  <Layout>
    <!-- ICON -->
    <template #icon>new_releases</template>

    <!-- TITLE -->
    <template #title>{{ $t('Version.title') }}</template>

    <!-- BODY -->
    <template #body>   
      <v-flex>
        <h2 class="subheading font-weight-bold mt-4 ml-4">{{ $t('Version.mfgVersion.title') }}</h2>
        <h2 class="subheading font-weight-regular mt-3 ml-4">{{ version }}</h2>
      </v-flex>
    </template>
  </Layout>
</template>
<script>
export default {
  name: "Version",
  data: () => ({
    version: process.env.VUE_APP_VERSION
  }),
  components: {
    Layout: () => import("@/layouts/Layout.version"),
  },
}
</script>  
<style>

</style>